import { TwinfieldService } from "../services/twinfield.service";

interface ITwinfieldScope extends ng.IScope {
    status: boolean;
    nonce: string;
    twinfieldUrl: string;
}

class TwinfieldController implements ng.IComponentController {

    /**
     * Constructor
     *
     * @return  {void}
     */

    constructor(
        private TwinfieldService: TwinfieldService,
        public $scope: ITwinfieldScope,
        private $state: ng.ui.IStateService,
        private localStorageService: ng.local.storage.ILocalStorageService,
        private $location: ng.ILocationService
    ){
        'ngInject';
    }

    /**
     * Initiator
     *
     * @return  {void}
     */

    public $onInit = () => {

        /** Set twinfield URI nonces */

        this.$scope.nonce = this.generateNonce();
        this.$scope.twinfieldUrl = 'https://login.twinfield.com/auth/authentication/connect/authorize'
            + '?client_id=brainsweb'
            + '&response_type=code'
            + '&scope=openid+twf.user+twf.organisation+twf.organisationUser+offline_access'
            + '&redirect_uri=' + window.location.protocol + '//' + window.location.host + '/app/twinfield'
            + '&state=' + this.generateNonce()
            + '&nonce=' + this.generateNonce();

        /** Get status */

        this.TwinfieldService.verifyToken().then(( status:any ) => {

            this.$scope.status = status; console.log( 'token: verify ' + this.$scope.status );

        }).catch(() => { 
        
            this.$scope.status = false; });

    }

    /**
     * Generate a nonces

     * @return  {string}  Nonce
     */

    public generateNonce(): string {

        return ( Math.floor((Math.random()*6)+1) * new Date().getTime() ).toString(); }

    /**
     * Redirect to Twinfield for oAuth2 code retrieval
     *
     * @return  {void}
     */

    public authenticateTwinfield(){

        parent.location.href = this.$scope.twinfieldUrl;
    }

}

export const twinfieldComponent: ng.IComponentOptions = {
    controller: TwinfieldController,
    template: <string>require('./twinfield.html')
};


// WEBPACK FOOTER //
// ./src/app/components/twinfield.component.ts